import { useApiQuery } from '../useApiQuery'

export const useGetTermsByOrganization = (organizationId, options = {}) => {
  const query = useApiQuery(
    ['termsByOrganization', organizationId],
    'schools',
    `/organizations/${organizationId}/terms`,
    {
      enabled: Boolean(organizationId),
      ...options
    }
  )

  return {
    data: query.data,
    loading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
    isFetching: query.isFetching
  }
}
